<template>
  <div class="modal-popup">
    <div class="modal fade" id="createDiscountModal" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" v-if="booking != null">
          <div class="modal-header">
            <h3 class="title mt-2 ml-2">İndirim Kaydı Oluştur</h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="la la-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="contact-form-action">
              <form method="post">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="input-box">
                      <label class="label-text">İndirim Tutarı</label>
                      <input class="form-control" v-model="bookingDiscount.discountPrice" id="discountAmount" type="number" placeholder="">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <span v-if="bookingDiscount.discountPrice > booking.totalPrice" style="color: red; font-size: 12px">İndirim miktarı rezervasyon tutarından fazla.</span>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
<!--            <div class="row">-->
<!--              <span v-if="bookingDiscount.discountPrice > booking.totalPrice" style="color: red">İndirim miktarı rezervasyon tutarından fazla.</span>-->
<!--            </div>-->
            <button type="button" class="btn font-weight-bold font-size-15 color-text-2 mr-2" data-dismiss="modal">Cancel</button>
            <button @click="accept" type="button" class="theme-btn theme-btn-small">Onaylıyorum</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateDiscountPopup",
  data:function (){
    return{
      bookingDiscount: {
        discountPrice: 0
      }
    }
  },
  computed:{
    agencyList:{
      get(){
        return this.$store.getters.getAgencyList
      }
    },
    booking:{
      get(){
        return this.$store.getters.getBooking
      }
    }
  },
  methods:{
    accept(){
      // if(this.bookingDiscount.discountPrice !== 0){
        this.bookingDiscount.bookingId = this.booking.id
        this.$store.dispatch("createBookingDiscount",this.bookingDiscount).then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Başarılı',
            text: '',
          })
          window.location.reload();
        })
      // }else{
      //   $("#discountAmount").addClass("error");
      // }

    }
  },
  updated() {
    setTimeout(function () {
      $(".select-contain-select").selectpicker('refresh');
    }, 100);
    $(".select-contain-select").selectpicker({
      size: 5,
      noneSelectedText: 'Select One'
    });
  }
}
</script>

<style scoped>

.discountAmountExceeded{
  pointer-events: none;
  opacity: 0.4;
}

</style>